//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class KegFinderApiClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    /**
     * @return Success
     */
    emails( cancelToken?: CancelToken | undefined): Promise<EmailViewModel[]> {
        let url_ = this.baseUrl + "/Emails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmails(_response);
        });
    }

    protected processEmails(response: AxiosResponse): Promise<EmailViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmailViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmailViewModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailViewModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    contactForm(body: ContactFormBindingModel | undefined, cancelToken?: CancelToken | undefined): Promise<EmailViewModel[]> {
        let url_ = this.baseUrl + "/Emails/ContactForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processContactForm(_response);
        });
    }

    protected processContactForm(response: AxiosResponse): Promise<EmailViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            let result204: any = null;
            let resultData204  = _responseText;
            if (Array.isArray(resultData204)) {
                result204 = [] as any;
                for (let item of resultData204)
                    result204!.push(EmailViewModel.fromJS(item));
            }
            else {
                result204 = <any>null;
            }
            return Promise.resolve<EmailViewModel[]>(result204);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmailViewModel[]>(null as any);
    }

    /**
     * @return Success
     */
    locationsGET(id: string, cancelToken?: CancelToken | undefined): Promise<LocationViewModel> {
        let url_ = this.baseUrl + "/Locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocationsGET(_response);
        });
    }

    protected processLocationsGET(response: AxiosResponse): Promise<LocationViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationViewModel.fromJS(resultData200);
            return Promise.resolve<LocationViewModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationViewModel>(null as any);
    }

    /**
     * @return No Content
     */
    locationsDELETE(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocationsDELETE(_response);
        });
    }

    protected processLocationsDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    locationsPUT(id: string, body: UpdateLocationBindingModel | undefined, cancelToken?: CancelToken | undefined): Promise<LocationViewModel> {
        let url_ = this.baseUrl + "/Locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocationsPUT(_response);
        });
    }

    protected processLocationsPUT(response: AxiosResponse): Promise<LocationViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationViewModel.fromJS(resultData200);
            return Promise.resolve<LocationViewModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    report(id: string, body: ReportLocationBindingModel | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Locations/{id}/Report";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReport(_response);
        });
    }

    protected processReport(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    locationsPOST(body: CreateLocationBindingModel | undefined, cancelToken?: CancelToken | undefined): Promise<LocationViewModel> {
        let url_ = this.baseUrl + "/Locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLocationsPOST(_response);
        });
    }

    protected processLocationsPOST(response: AxiosResponse): Promise<LocationViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationViewModel.fromJS(resultData200);
            return Promise.resolve<LocationViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: SearchLocationsBindingModel | undefined, cancelToken?: CancelToken | undefined): Promise<LocationSearchResultsViewModel> {
        let url_ = this.baseUrl + "/Locations/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<LocationSearchResultsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LocationSearchResultsViewModel.fromJS(resultData200);
            return Promise.resolve<LocationSearchResultsViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationSearchResultsViewModel>(null as any);
    }

    /**
     * @return Success
     */
    machines( cancelToken?: CancelToken | undefined): Promise<MachineViewModel[]> {
        let url_ = this.baseUrl + "/Machines";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMachines(_response);
        });
    }

    protected processMachines(response: AxiosResponse): Promise<MachineViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MachineViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<MachineViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MachineViewModel[]>(null as any);
    }

    /**
     * @param postcode (optional) 
     * @return Success
     */
    lookup(postcode: string | undefined, cancelToken?: CancelToken | undefined): Promise<CoordinatesViewModel> {
        let url_ = this.baseUrl + "/Postcode/Lookup?";
        if (postcode === null)
            throw new Error("The parameter 'postcode' cannot be null.");
        else if (postcode !== undefined)
            url_ += "postcode=" + encodeURIComponent("" + postcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLookup(_response);
        });
    }

    protected processLookup(response: AxiosResponse): Promise<CoordinatesViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CoordinatesViewModel.fromJS(resultData200);
            return Promise.resolve<CoordinatesViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CoordinatesViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    nearest(body: CoordinatesBindingModel | undefined, cancelToken?: CancelToken | undefined): Promise<NearestPostcodeViewModel> {
        let url_ = this.baseUrl + "/Postcode/Nearest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNearest(_response);
        });
    }

    protected processNearest(response: AxiosResponse): Promise<NearestPostcodeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NearestPostcodeViewModel.fromJS(resultData200);
            return Promise.resolve<NearestPostcodeViewModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NearestPostcodeViewModel>(null as any);
    }

    /**
     * @return Success
     */
    submissionsAll( cancelToken?: CancelToken | undefined): Promise<SubmissionViewModel[]> {
        let url_ = this.baseUrl + "/Submissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmissionsAll(_response);
        });
    }

    protected processSubmissionsAll(response: AxiosResponse): Promise<SubmissionViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubmissionViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SubmissionViewModel[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SubmissionViewModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return No Content
     */
    submissionsPOST(body: CreateSubmissionBindingModel | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Submissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmissionsPOST(_response);
        });
    }

    protected processSubmissionsPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    submissionsDELETE(id: string, cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Submissions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSubmissionsDELETE(_response);
        });
    }

    protected processSubmissionsDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ContactFormBindingModel implements IContactFormBindingModel {
    captcha?: string | null;
    email?: string | null;
    message?: string | null;
    name?: string | null;

    constructor(data?: IContactFormBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"] !== undefined ? _data["captcha"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ContactFormBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactFormBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha !== undefined ? this.captcha : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IContactFormBindingModel {
    captcha?: string | null;
    email?: string | null;
    message?: string | null;
    name?: string | null;
}

export class CoordinatesBindingModel implements ICoordinatesBindingModel {
    latitude?: number | null;
    longitude?: number | null;

    constructor(data?: ICoordinatesBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
        }
    }

    static fromJS(data: any): CoordinatesBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinatesBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        return data;
    }
}

export interface ICoordinatesBindingModel {
    latitude?: number | null;
    longitude?: number | null;
}

export class CoordinatesViewModel implements ICoordinatesViewModel {
    latitude?: number;
    longitude?: number;

    constructor(data?: ICoordinatesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
        }
    }

    static fromJS(data: any): CoordinatesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinatesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        return data;
    }
}

export interface ICoordinatesViewModel {
    latitude?: number;
    longitude?: number;
}

export class CreateLocationBindingModel implements ICreateLocationBindingModel {
    coords?: CoordinatesBindingModel;
    comment?: string | null;
    machines?: string[] | null;
    name?: string | null;
    postcode?: string | null;
    submissionId?: string | null;
    submitterEmail?: string | null;
    submitterName?: string | null;

    constructor(data?: ICreateLocationBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coords = _data["coords"] ? CoordinatesBindingModel.fromJS(_data["coords"]) : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            if (Array.isArray(_data["machines"])) {
                this.machines = [] as any;
                for (let item of _data["machines"])
                    this.machines!.push(item);
            }
            else {
                this.machines = <any>null;
            }
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.postcode = _data["postcode"] !== undefined ? _data["postcode"] : <any>null;
            this.submissionId = _data["submissionId"] !== undefined ? _data["submissionId"] : <any>null;
            this.submitterEmail = _data["submitterEmail"] !== undefined ? _data["submitterEmail"] : <any>null;
            this.submitterName = _data["submitterName"] !== undefined ? _data["submitterName"] : <any>null;
        }
    }

    static fromJS(data: any): CreateLocationBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLocationBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coords"] = this.coords ? this.coords.toJSON() : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item);
        }
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["postcode"] = this.postcode !== undefined ? this.postcode : <any>null;
        data["submissionId"] = this.submissionId !== undefined ? this.submissionId : <any>null;
        data["submitterEmail"] = this.submitterEmail !== undefined ? this.submitterEmail : <any>null;
        data["submitterName"] = this.submitterName !== undefined ? this.submitterName : <any>null;
        return data;
    }
}

export interface ICreateLocationBindingModel {
    coords?: CoordinatesBindingModel;
    comment?: string | null;
    machines?: string[] | null;
    name?: string | null;
    postcode?: string | null;
    submissionId?: string | null;
    submitterEmail?: string | null;
    submitterName?: string | null;
}

export class CreateSubmissionBindingModel implements ICreateSubmissionBindingModel {
    captcha?: string | null;
    comment?: string | null;
    machines?: string[] | null;
    name?: string | null;
    email?: string | null;
    retailerName?: string | null;
    retailerPostcode?: string | null;

    constructor(data?: ICreateSubmissionBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"] !== undefined ? _data["captcha"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            if (Array.isArray(_data["machines"])) {
                this.machines = [] as any;
                for (let item of _data["machines"])
                    this.machines!.push(item);
            }
            else {
                this.machines = <any>null;
            }
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.retailerName = _data["retailerName"] !== undefined ? _data["retailerName"] : <any>null;
            this.retailerPostcode = _data["retailerPostcode"] !== undefined ? _data["retailerPostcode"] : <any>null;
        }
    }

    static fromJS(data: any): CreateSubmissionBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubmissionBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha !== undefined ? this.captcha : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item);
        }
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["retailerName"] = this.retailerName !== undefined ? this.retailerName : <any>null;
        data["retailerPostcode"] = this.retailerPostcode !== undefined ? this.retailerPostcode : <any>null;
        return data;
    }
}

export interface ICreateSubmissionBindingModel {
    captcha?: string | null;
    comment?: string | null;
    machines?: string[] | null;
    name?: string | null;
    email?: string | null;
    retailerName?: string | null;
    retailerPostcode?: string | null;
}

export class EmailViewModel implements IEmailViewModel {
    readonly id?: string;
    readonly createdDate?: Date | null;
    readonly updatedDate?: Date | null;
    readonly from?: string | null;
    readonly message?: string | null;
    readonly subject?: string | null;
    readonly to?: string | null;

    constructor(data?: IEmailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"] !== undefined ? _data["id"] : <any>null;
            (<any>this).createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            (<any>this).updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            (<any>this).from = _data["from"] !== undefined ? _data["from"] : <any>null;
            (<any>this).message = _data["message"] !== undefined ? _data["message"] : <any>null;
            (<any>this).subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
            (<any>this).to = _data["to"] !== undefined ? _data["to"] : <any>null;
        }
    }

    static fromJS(data: any): EmailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["from"] = this.from !== undefined ? this.from : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["subject"] = this.subject !== undefined ? this.subject : <any>null;
        data["to"] = this.to !== undefined ? this.to : <any>null;
        return data;
    }
}

export interface IEmailViewModel {
    id?: string;
    createdDate?: Date | null;
    updatedDate?: Date | null;
    from?: string | null;
    message?: string | null;
    subject?: string | null;
    to?: string | null;
}

export class LocationSearchResultsViewModel implements ILocationSearchResultsViewModel {
    readonly results?: LocationViewModel[] | null;

    constructor(data?: ILocationSearchResultsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                (<any>this).results = [] as any;
                for (let item of _data["results"])
                    (<any>this).results!.push(LocationViewModel.fromJS(item));
            }
            else {
                (<any>this).results = <any>null;
            }
        }
    }

    static fromJS(data: any): LocationSearchResultsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationSearchResultsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocationSearchResultsViewModel {
    results?: LocationViewModel[] | null;
}

export class LocationViewModel implements ILocationViewModel {
    readonly id?: string;
    readonly createdDate?: Date | null;
    readonly updatedDate?: Date | null;
    readonly comment?: string | null;
    coords?: CoordinatesViewModel;
    readonly name?: string | null;
    readonly postcode?: string | null;
    readonly submitterName?: string | null;
    readonly submitterEmail?: string | null;
    readonly machines?: MachineViewModel[] | null;

    constructor(data?: ILocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"] !== undefined ? _data["id"] : <any>null;
            (<any>this).createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            (<any>this).updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            (<any>this).comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.coords = _data["coords"] ? CoordinatesViewModel.fromJS(_data["coords"]) : <any>null;
            (<any>this).name = _data["name"] !== undefined ? _data["name"] : <any>null;
            (<any>this).postcode = _data["postcode"] !== undefined ? _data["postcode"] : <any>null;
            (<any>this).submitterName = _data["submitterName"] !== undefined ? _data["submitterName"] : <any>null;
            (<any>this).submitterEmail = _data["submitterEmail"] !== undefined ? _data["submitterEmail"] : <any>null;
            if (Array.isArray(_data["machines"])) {
                (<any>this).machines = [] as any;
                for (let item of _data["machines"])
                    (<any>this).machines!.push(MachineViewModel.fromJS(item));
            }
            else {
                (<any>this).machines = <any>null;
            }
        }
    }

    static fromJS(data: any): LocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["coords"] = this.coords ? this.coords.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["postcode"] = this.postcode !== undefined ? this.postcode : <any>null;
        data["submitterName"] = this.submitterName !== undefined ? this.submitterName : <any>null;
        data["submitterEmail"] = this.submitterEmail !== undefined ? this.submitterEmail : <any>null;
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocationViewModel {
    id?: string;
    createdDate?: Date | null;
    updatedDate?: Date | null;
    comment?: string | null;
    coords?: CoordinatesViewModel;
    name?: string | null;
    postcode?: string | null;
    submitterName?: string | null;
    submitterEmail?: string | null;
    machines?: MachineViewModel[] | null;
}

export class MachineViewModel implements IMachineViewModel {
    readonly id?: string;
    readonly name?: string | null;

    constructor(data?: IMachineViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"] !== undefined ? _data["id"] : <any>null;
            (<any>this).name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): MachineViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MachineViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IMachineViewModel {
    id?: string;
    name?: string | null;
}

export class NearestPostcodeViewModel implements INearestPostcodeViewModel {
    postcode?: string | null;

    constructor(data?: INearestPostcodeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postcode = _data["postcode"] !== undefined ? _data["postcode"] : <any>null;
        }
    }

    static fromJS(data: any): NearestPostcodeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new NearestPostcodeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postcode"] = this.postcode !== undefined ? this.postcode : <any>null;
        return data;
    }
}

export interface INearestPostcodeViewModel {
    postcode?: string | null;
}

export class ReportLocationBindingModel implements IReportLocationBindingModel {
    captcha?: string | null;
    email?: string | null;
    message?: string | null;
    name?: string | null;

    constructor(data?: IReportLocationBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.captcha = _data["captcha"] !== undefined ? _data["captcha"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ReportLocationBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportLocationBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["captcha"] = this.captcha !== undefined ? this.captcha : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IReportLocationBindingModel {
    captcha?: string | null;
    email?: string | null;
    message?: string | null;
    name?: string | null;
}

export class SearchLocationsBindingModel implements ISearchLocationsBindingModel {
    machines?: string[] | null;
    postcode?: string | null;
    query?: string | null;

    constructor(data?: ISearchLocationsBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["machines"])) {
                this.machines = [] as any;
                for (let item of _data["machines"])
                    this.machines!.push(item);
            }
            else {
                this.machines = <any>null;
            }
            this.postcode = _data["postcode"] !== undefined ? _data["postcode"] : <any>null;
            this.query = _data["query"] !== undefined ? _data["query"] : <any>null;
        }
    }

    static fromJS(data: any): SearchLocationsBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new SearchLocationsBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item);
        }
        data["postcode"] = this.postcode !== undefined ? this.postcode : <any>null;
        data["query"] = this.query !== undefined ? this.query : <any>null;
        return data;
    }
}

export interface ISearchLocationsBindingModel {
    machines?: string[] | null;
    postcode?: string | null;
    query?: string | null;
}

export class SubmissionViewModel implements ISubmissionViewModel {
    readonly id?: string;
    readonly comment?: string | null;
    readonly email?: string | null;
    readonly name?: string | null;
    readonly retailerName?: string | null;
    readonly retailerPostcode?: string | null;
    readonly createdDate?: Date | null;
    readonly updatedDate?: Date | null;
    readonly machines?: MachineViewModel[] | null;

    constructor(data?: ISubmissionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).id = _data["id"] !== undefined ? _data["id"] : <any>null;
            (<any>this).comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            (<any>this).email = _data["email"] !== undefined ? _data["email"] : <any>null;
            (<any>this).name = _data["name"] !== undefined ? _data["name"] : <any>null;
            (<any>this).retailerName = _data["retailerName"] !== undefined ? _data["retailerName"] : <any>null;
            (<any>this).retailerPostcode = _data["retailerPostcode"] !== undefined ? _data["retailerPostcode"] : <any>null;
            (<any>this).createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            (<any>this).updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            if (Array.isArray(_data["machines"])) {
                (<any>this).machines = [] as any;
                for (let item of _data["machines"])
                    (<any>this).machines!.push(MachineViewModel.fromJS(item));
            }
            else {
                (<any>this).machines = <any>null;
            }
        }
    }

    static fromJS(data: any): SubmissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SubmissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["retailerName"] = this.retailerName !== undefined ? this.retailerName : <any>null;
        data["retailerPostcode"] = this.retailerPostcode !== undefined ? this.retailerPostcode : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubmissionViewModel {
    id?: string;
    comment?: string | null;
    email?: string | null;
    name?: string | null;
    retailerName?: string | null;
    retailerPostcode?: string | null;
    createdDate?: Date | null;
    updatedDate?: Date | null;
    machines?: MachineViewModel[] | null;
}

export class UpdateLocationBindingModel implements IUpdateLocationBindingModel {
    comment?: string | null;
    coords?: CoordinatesBindingModel;
    name?: string | null;
    machines?: string[] | null;
    postcode?: string | null;

    constructor(data?: IUpdateLocationBindingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.coords = _data["coords"] ? CoordinatesBindingModel.fromJS(_data["coords"]) : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["machines"])) {
                this.machines = [] as any;
                for (let item of _data["machines"])
                    this.machines!.push(item);
            }
            else {
                this.machines = <any>null;
            }
            this.postcode = _data["postcode"] !== undefined ? _data["postcode"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateLocationBindingModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLocationBindingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["coords"] = this.coords ? this.coords.toJSON() : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.machines)) {
            data["machines"] = [];
            for (let item of this.machines)
                data["machines"].push(item);
        }
        data["postcode"] = this.postcode !== undefined ? this.postcode : <any>null;
        return data;
    }
}

export interface IUpdateLocationBindingModel {
    comment?: string | null;
    coords?: CoordinatesBindingModel;
    name?: string | null;
    machines?: string[] | null;
    postcode?: string | null;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors?: { [key: string]: string[]; } | null;

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
            else {
                this.errors = <any>null;
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = this.errors[key] !== undefined ? this.errors[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IValidationProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors?: { [key: string]: string[]; } | null;

    [key: string]: any;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}